import { Breadcrumb } from 'antd';
import styled from 'styled-components';

export default styled(Breadcrumb)`
	// Add your styles here
`;
